import {
  graphql,
  PreloadedQuery,
  usePreloadedQuery,
  useQueryLoader,
} from 'utils/graphClient';
import { useSafeRelay } from 'utils/graphClient';
import {
  searchQuery,
  searchQuery$variables,
} from './__generated__/searchQuery.graphql';

export type SearchReference = PreloadedQuery<searchQuery>;

const SearchQuery = graphql`
  query searchQuery(
    $query: String!
    $spaceIds: [ID!]
    $types: [SearchTypeFilter!]
  ) {
    search(query: $query, spaceIds: $spaceIds, types: $types) {
      totalCount
      nodes {
        ...SearchResult
        node {
          ... on Event {
            publishState
          }
          ... on FolderNodeInterface {
            publishState
          }
        }
      }
    }
  }
`;

export const useSearchQueryLoader = () => {
  return useQueryLoader<searchQuery>(SearchQuery);
};

export const usePreloadedSearchQuery = (searchRef: SearchReference) => {
  return usePreloadedQuery<searchQuery>(SearchQuery, searchRef);
};

export const useLazyLoadSearchInfoQuery = (props: searchQuery$variables) => {
  const { useLazyLoadQuery } = useSafeRelay();

  return useLazyLoadQuery<searchQuery>(SearchQuery, props);
};
